import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import hasProperty from "lodash/has";
import Textbox from "components/Forms/Elements/Textbox";
import PropTypes from "prop-types";
import * as inputTypes from "components/Forms/InputTypes";

/**
 * options for formErrorClass:
 * form-error (default)
 * form-error-inverse
 *
 * specially made for components of manage dashboard like(manage users,metadata and client)
 *  */
function ManageFilters({
  id,
  name = "auto",
  errors = {},
  errorKey,
  type = inputTypes.TEXTBOX,
  classes = "",
  placeholder = "",
  fieldValue = "",
  autoComplete = "on",
  onChange,
  onReturnKey,
  onClick = () => {},
  onBlur = () => {},
  onFocus = () => {},
  onKeyUp = () => {},
  formErrorClass = "form-error",
  getAllData,
  propertyValue,
  propertyField
}) {
  const dispatch = useDispatch();

  const [formError, setFormError] = useState("");
  const [readOnly, setReadOnly] = useState(true);
  const [formErrorMessage, setFormErrorMessage] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);

  useEffect(() => {
    setSelectedItem(fieldValue);
  }, [fieldValue]);

  useEffect(() => {
    setFormError("");
    setFormErrorMessage("");

    if (
      hasProperty(errors, "response.data.data.errors.length") &&
      errors.response.data.data.errors.length > 0
    ) {
      for (const iterator of errors.response.data.data.errors) {
        if (iterator.field === errorKey) {
          setFormError(formErrorClass || "form-error");
          setFormErrorMessage(iterator.message);
          break;
        }
      }
    }
  }, [name, errorKey, errors, formErrorClass]);

  const onInputChange = () => {
    setFormError("");
    setFormErrorMessage("");
  };

  return (
    <span>
      <div className="search">
        <div className="search-inputs">
          <div className="searchIcon">
            <i className="fa fa-search" aria-hidden="true"></i>
          </div>
          <input
            id={id}
            type={type}
            name={name}
            placeholder={placeholder}
            value={
              typeof selectedItem === "string"
                ? selectedItem
                : selectedItem && selectedItem[propertyValue]
                ? selectedItem[propertyValue]
                : ""
            }
            autoComplete={autoComplete}
            readOnly={readOnly}
            onMouseEnter={e => setReadOnly(false)}
            onFocus={e => {
              setReadOnly(false);
              onFocus(e);
            }}
            className={`form-input ${classes} ${formError}`}
            onChange={e => {
              onInputChange(e);
              setSelectedItem(e.target.value);
              dispatch(getAllData({ [propertyField]: e.target.value }));
            }}
            onClick={e => {
              setShowSuggestions(!showSuggestions);
            }}
            onKeyUp={e => {
              if (e.which === 27) {
                setShowSuggestions(false);
                setSelectedItem("");
                dispatch(getAllData({}));
              }
            }}
          />
        </div>
      </div>
      {formErrorMessage && <div className={formError}>{formErrorMessage}</div>}
    </span>
  );
}

Textbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onReturnKey: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyUp: PropTypes.func,
  errors: PropTypes.object,
  errorKey: PropTypes.string.isRequired, // The string that the api error returns in the "field" key
  type: PropTypes.string,
  classes: PropTypes.string,
  placeholder: PropTypes.string,
  fieldValue: PropTypes.any,
  autoComplete: PropTypes.string,
  formErrorClass: PropTypes.string,
  getAllData: PropTypes.func.isRequired, // API function which we want to call like(getAllClient,getAllUser,etc.)
  propertyValue: PropTypes.string,
  propertyField: PropTypes.string // field by which we want to search in DB collection
};

export default ManageFilters;
